import { Image } from '@chakra-ui/image'
import { Flex, Text } from '@chakra-ui/layout'
import { Td, Tr } from '@chakra-ui/table'
import { VscFilePdf } from 'react-icons/vsc'
import { EditItem } from '../EditItem'
import { user } from '../../../helpers/user'
import { ExcludeButton } from '../../../components/ExcludeButton'
import { useMutation } from 'react-query'
import { excludeItem } from '../requests'
import { useToast } from '@chakra-ui/react'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'

export function CardItem({ item, index, refetch }) {
  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading: loading } = useMutation({
    mutationFn: ({ item, codusu }) => excludeItem(item, codusu),
    mutationKey: 'exclude-item',
    onSuccess: () => {
      refetch()
      toast({
        title: 'Item excluído com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },

    onError: () => {
      toast({
        title: 'Erro ao excluir item',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleDeleteItem() {
    try {
      await mutateAsync({
        item,
        codusu: user.codigo_usuario,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Tr border="1px solid #e2e8f0" marginBottom="1rem">
      <Td>
        <Flex gap="1rem" maxW="fit-content">
          <div>
            {' '}
            <Image
              src={item.IMAGEM_PROD}
              alt="Imagem do produto"
              width={150}
              height={150}
              objectFit="cover"
              padding="1.6rem"
            />
          </div>
          <Flex flexDir="column">
            <Flex flexDir="column">
              <Text
                fontSize="1rem"
                fontWeight="bold"
                marginTop="7px"
                marginBottom="0"
              >
                {item.NOME}
              </Text>
              <Text fontSize=".8rem" fontWeight="500">
                Cod {item.CODPROD}{' '}
                <Text
                  as="a"
                  href={item.CATEGORIA}
                  textDecoration={'none'}
                  target="_blank"
                  rel="noreferrer"
                >
                  + Mais informações
                </Text>
              </Text>
            </Flex>

            <span
              style={{
                fontSize: '.8rem',
              }}
            >
              Cor: {firstLetterUpperCaseAndRestLowerCase(item.DS_COR?.nome_cor)}
            </span>
            <span
              style={{
                fontSize: '.8rem',
              }}
            >
              Gravação: <span>{item?.DS_IMPR?.nome_impressao} </span>
            </span>
            <span
              style={{
                fontSize: '.8rem',
              }}
            >
              Impressões: <span>{item.AD_QTDBATIDA} </span>
            </span>
            <span
              style={{
                fontSize: '.8rem',
              }}
            >
              Prazo de produção:{' '}
              <span>
                {item.PRAZO_ENTREGA}{' '}
                {item.PRAZO_ENTREGA.length > 1 ? 'dias úteis' : 'dia util'}{' '}
              </span>
            </span>
          </Flex>
        </Flex>
      </Td>
      <Td textAlign="center">
        <p>{parseInt(item.QTDNEG)}</p>
      </Td>

      <Td textAlign="center">
        <p>
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(item.VALOR_UNIT)}
        </p>
      </Td>
      <Td textAlign="center">
        <p>
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(item.VALOR_TOTAL_ITEM)}
        </p>
      </Td>
      <Td>
        <Flex alignItems="center" justifyContent="center" gap="1rem">
          {/* <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
          >
            <Text fontSize=".9rem">Visualizar</Text>

            <a href={item.LINK_LAYOUT} target="_blank" rel="noreferrer">
              <VscFilePdf size="2rem" color="#7fbc03" />
            </a>
          </Flex> */}

          <EditItem item={item} index={index} refetch={refetch} />
          <ExcludeButton onClick={handleDeleteItem} loading={loading} />
        </Flex>
      </Td>
    </Tr>
  )
}
